import { Button } from '@mui/material';
import useRandomProfile from '../../../hook/useRandomProfile';

export default function ExpertAnswer({ data }) {
  const { randomProfile } = useRandomProfile();

  return (
    <div className="w-full flex flex-col justify-start gap-2 items-start ">
      <div className="text-[14px] font-[700] text-[#1C1C1C] mt-10">전문가 답변</div>
      <div className="w-full flex justify-start gap-2 items-center border-b border-[#EAEAEA] py-3">
        <div
          className="shrink-0 min-w-[52px] min-h-[52px] max-h-[52px] max-w-[52px] bg-[#FFF] border border-[#EAEAEA] overflow-hidden flex items-center justify-center rounded-[24px]"
          style={{ background: Math.random() > 0.5 ? '#fff' : '#F0FCFC' }}
        >
          <img
            src={data?.author?.imageUrl ? data?.author?.imageUrl : randomProfile()}
            alt="profile"
            className="w-[52px] object-cover rounded-full"
          />
        </div>
        <div className="gap-1 flex flex-col items-start justify-between font-[400] text-[#363636] text-[12px]">
          <div className="font-[700] text-[#1C1C1C] text-[16px]">{data?.author?.nickName}</div>
          <div className="font-[400] text-[#969696] text-[12px]">{data?.author?.career}</div>
        </div>
      </div>
      <div className="w-full mt-2 flex flex-col justify-start items-start gap-5">
        <div className="text-[14px]" dangerouslySetInnerHTML={{ __html: data?.content }} />
        <div className="text-[12px] text-[#767676]">
          *전문가와의 1:1 상담 기능은 추후 업데이트 예정입니다.
        </div>
        <Button fullWidth variant="contained" disabled>
          1:1 상담 예약 (30,000원)
        </Button>
      </div>
    </div>
  );
}
